import ShippingMethodsIsMatchingShippingMethod from "@commercetools-local/topics/shipping-methods/is-matching-shipping-method.mdx";
import CustomFieldsSetCustomFieldUpdateActionGeneric from "@commercetools-local/topics/custom-fields/set-custom-field-update-action-generic.mdx";
import * as React from 'react';
export default {
  ShippingMethodsIsMatchingShippingMethod,
  CustomFieldsSetCustomFieldUpdateActionGeneric,
  React
};